import { useEffect, useState } from "react";
import api from "../utils/axios";

import { formatCurrency, formatNumber, formatAmount } from "../helpers";
interface DepositItem {
  transaction_id: number;
  uid: string;
  name: string;
  amount: number;
  status: string;
  transaction_date: string;

  payment_type: "crypto" | "bank" | "online";

  paymentmethod: string;
  transaction_type?: string;

  utr_no: string | null;
  txhash: string | null;
  wallet_address: string | null;
  transactionid: string | null;

  receipt?: string;

  totalbonuspercentage?: number;
}

const ManualDeposit = () => {
  const [tab, setTab] = useState<"crypto" | "bank" | "online">("online");
  const [data, setData] = useState<DepositItem[]>([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");

  const token = localStorage.getItem("token");

  useEffect(() => {
  fetchData();
}, [tab, page, search]);

  const fetchData = async () => {
    const res = await api.get(
      `/getManualDepositData?page=${page}&limit=10`,
      {
        params: {
          payment_type: tab,
          search,
        },
        headers: { Authorization: token },
      }
    );

    setData(res?.data?.data || []);
    setTotalPages(res?.data?.totalPages || 1);
  };

  const handleAction = async (d: DepositItem, isApproved: boolean) => {
    await api.post(
      "/approveRejectManualDeposit",
      {
        trx: d,
        isApproved,
      },
      { headers: { Authorization: token } }
    );

    fetchData();
  };

  const filteredData = data.filter((d) => {
  const keyword = search.toLowerCase();

  return (
    String(d.uid || "")
      .toLowerCase()
      .includes(keyword) ||
    String(d.utr_no || "").includes(keyword)
  );
});

  return (
    <div className="space-y-6">
      {/* ================= HEADER ================= */}
      <div>
        <h1 className="text-2xl font-bold text-gray-800">Manual Deposits</h1>
        <p className="text-sm text-gray-500">
          Manage Crypto & Bank deposit approvals
        </p>
      </div>

      {/* ================= SEARCH ================= */}
<div className="flex justify-between items-center">
  <input
    type="text"
    placeholder="Search by Transaction ID or User ID"
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    className="w-full max-w-sm px-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-300"
  />
</div>

      {/* ================= TABS ================= */}
      <div className="flex gap-2">
        {["online"].map((t) => (
          <button
            key={t}
            onClick={() => {
              setTab(t as "crypto" | "bank" | "online");
              setPage(1);
            }}
            className={`px-4 py-2 rounded-lg text-sm font-medium ${
              tab === t
                ? "bg-gray-900 text-white"
                : "bg-gray-100 text-gray-700"
            }`}
          >
            {t === "crypto" ? "Crypto Deposits" : t === "online" ? "Online Deposits" : "Bank Deposits"}
          </button>
        ))}
      </div>

      {/* ================= TABLE ================= */}
      <div className="bg-white border rounded-2xl shadow-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-600">
            <tr>
              <th className="px-4 py-3">#</th>
              <th className="px-4 py-3">User</th>
              <th className="px-4 py-3">Amount</th>
              <th className="px-4 py-3">Bonus</th>

              {tab === "online" ? (
                <>
                  <th className="px-4 py-3">Payment Method</th>
                  <th className="px-4 py-3">UTR</th>
                </>
              ) : (
                <>
                  <th className="px-4 py-3">Network</th>
                  <th className="px-4 py-3">TxHash</th>
                  <th className="px-4 py-3">Wallet</th>
                </>
              )}

              <th className="px-4 py-3">Receipt</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3">Action</th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={10} className="py-10 text-center text-gray-500">
                  No records found
                </td>
              </tr>
            ) : (
             filteredData.map((d, i) => (
                <tr
                  key={d.transaction_id}
                  className="border-t hover:bg-gray-50"
                >
                  <td className="px-4 py-3">{(page - 1) * 10 + i + 1}</td>

                  <td className="px-4 py-3 font-medium">
                    {d.name || d.uid}
                  </td>

                  {/* AMOUNT */}
                  <td className="px-4 py-3 font-semibold">
                    {formatCurrency(
                      d.payment_type === "crypto"
                        ? (d.amount * 140).toFixed(2)
                        : d.amount.toFixed(2)
                    )}
                  </td>

                  <td className="px-4 py-3">
                    {formatCurrency(
                      (d.amount * (d.totalbonuspercentage ?? 0)) / 100
                    )}
                  </td>

                  {/* BANK */}
                  {tab === "online" ? (
                    <>
                      <td className="px-4 py-3">
                        {d.paymentmethod || "-"}
                      </td>

                      <td className="px-4 py-3 text-xs">
                        {d.utr_no || "-"}
                      </td>
                    </>
                  ) : (
                    <>
                      {/* CRYPTO */}
                      <td className="px-4 py-3">
                        {d.paymentmethod || "-"}
                      </td>

                      <td className="px-4 py-3 text-xs">
                        {d.txhash || "-"}
                      </td>

                      <td className="px-4 py-3 text-xs">
                        {d.wallet_address || "-"}
                      </td>
                    </>
                  )}

                  {/* RECEIPT */}
                  <td className="px-4 py-3">
                    {d.receipt ? (
                      <a
                        href={`${process.env.REACT_APP_API_URL}/${d.receipt}`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 text-xs underline"
                      >
                        View
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>

                  {/* STATUS */}
                  <td className="px-4 py-3">
                    <span
                      className={`px-3 py-1 rounded-full text-xs ${
                        d.status === "pending"
                          ? "bg-yellow-100 text-yellow-700"
                          : d.status === "accepted"
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {d.status}
                    </span>
                  </td>

                  {/* DATE */}
                  <td className="px-4 py-3 text-xs">
                    {new Date(d.transaction_date).toLocaleString()}
                  </td>

                      {
                        d.payment_type === "online" && d.transaction_type ? (
                          <td className="px-4 py-3">
                            {d.transaction_type === "bank" ? "Bank Deposit" : d.transaction_type === "online" ? "Online Deposit" : "Crypto Deposit"}
                          </td>
                        ) : (
                          <td className="px-4 py-3">
                    {d.status === "pending" ? (
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleAction(d, true)}
                          className="px-3 py-1 bg-green-600 text-white rounded text-xs"
                        >
                          Accept
                        </button>

                        <button
                          onClick={() => handleAction(d, false)}
                          className="px-3 py-1 bg-red-600 text-white rounded text-xs"
                        >
                          Reject
                        </button>
                      </div>
                    ) : (
                      "—"
                    )}
                  </td>
                        )
                      }
                  {/* ACTION */}
                  
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* ================= PAGINATION ================= */}
        <div className="flex justify-between items-center px-4 py-3 border-t">
          <span className="text-sm text-gray-500">
            Page {page} of {totalPages}
          </span>

          <div className="flex gap-2">
            <button
              disabled={page <= 1}
              onClick={() => setPage(page - 1)}
              className="px-4 py-1 border rounded disabled:opacity-40"
            >
              Previous
            </button>

            <button
              disabled={page >= totalPages}
              onClick={() => setPage(page + 1)}
              className="px-4 py-1 border rounded disabled:opacity-40"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualDeposit;